import { useIsFetching } from "@tanstack/react-query"

import { HORIZONTAL_SIGNS_ROOT_QUERY_KEY } from "./queries/horizontalSigning/queryKeys"

export function useIsFetchingHorizontalSigning() {
    const isFetchingHorizontalSigningLayers = useIsFetching({ queryKey: [HORIZONTAL_SIGNS_ROOT_QUERY_KEY, "layer"] })

    return isFetchingHorizontalSigningLayers > 0
}